import React from "react";
import { TableBody } from "@mui/material";
import {
  Table as _Table,
  TableContainer,
  TableHeader,
  TableHeaderColumn,
  TableHeaderRow,
} from "../../Styles";
import { ArrowDownward } from "../Styles/Icons";
import SkuMappingRow from "./SkuMappingRow";
import { useVerticalScrollReset } from "../hooks/useScrollReset";

const Table = ({ aiSkuMappings, pageSize, pageNumber }) => {
  const scrollRef = useVerticalScrollReset([pageNumber, pageSize]);

  return (
    <TableContainer
      ref={scrollRef}
      sx={{
        height: "100% !important",
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
      }}
    >
      <_Table>
        <TableHeader>
          <TableHeaderRow
            sx={{
              position: "sticky", // ✅ Sticky header
              top: 0,
              zIndex: 5,
              backgroundColor: "#fff",

              "& > th:first-of-type": {
                borderTopLeftRadius: "12px",
                borderBottomLeftRadius: "12px",
              },
              "& > th:last-of-type": {
                borderTopRightRadius: "12px",
                borderBottomRightRadius: "12px",
              },
            }}
          >
            <TableHeaderColumn width={"10%"}>
              <TableHeaderColumnName name="Lab SKU" icon={<ArrowDownward />} />
            </TableHeaderColumn>

            <TableHeaderColumn width={"35%"}>
              <TableHeaderColumnName name="Lab Product" />
            </TableHeaderColumn>

            <TableHeaderColumn width={"5%"}>
              <TableHeaderColumnName name="" />
            </TableHeaderColumn>

            <TableHeaderColumn width={"30%"}>
              <TableHeaderColumnName name="Suggested Dentira Match" />
            </TableHeaderColumn>

            <TableHeaderColumn width={"10%"}>
              <TableHeaderColumnName name="Status" />
            </TableHeaderColumn>

            <TableHeaderColumn width={"10%"}>
              <TableHeaderColumnName name="Action" />
            </TableHeaderColumn>
          </TableHeaderRow>
        </TableHeader>

        <TableBody>
          {aiSkuMappings && aiSkuMappings.map(aiSkuMapping => (
            <SkuMappingRow key={aiSkuMapping._id} aiSkuMapping={aiSkuMapping} />
          ))}
        </TableBody>
      </_Table>
    </TableContainer>
  );
};

const TableHeaderColumnName = ({ name, icon = "" }) => (
  <div
    style={{
      fontWeight: 700,
      fontSize: "16px",
      textTransform: "none",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      height: "12.5px",
      whiteSpace: "normal",
      lineHeight: "1.2",
    }}
  >
    <span style={{ marginRight: "5px" }}>{name}</span>
    {icon}
  </div>
);

export default Table;
